var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExitCid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4524 5.54811C10.7648 5.86053 10.7648 6.36706 10.4524 6.67948L6.68117 10.4507C6.36875 10.7631 5.86222 10.7631 5.5498 10.4507C5.23738 10.1383 5.23738 9.63176 5.5498 9.31934L9.32103 5.54811C9.63345 5.23569 10.14 5.23569 10.4524 5.54811Z",
    fill: "#545C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4538 10.4505C10.1414 10.7629 9.63489 10.7629 9.32247 10.4505L5.55124 6.67921C5.23882 6.36679 5.23882 5.86026 5.55124 5.54784C5.86366 5.23542 6.37019 5.23542 6.68261 5.54784L10.4538 9.31908C10.7663 9.6315 10.7663 10.138 10.4538 10.4505Z",
    fill: "#545C62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitCid);
export default __webpack_public_path__ + "static/media/ic-exit-cid.1ad9ad0318b50b524631332339ac96cd.svg";
export { ForwardRef as ReactComponent };